import React, { memo } from "react";
import { VerifiedButton } from "components/buttons/VerifiedButton";
import { TextArea } from "components/inputs/TextArea/TextArea";
import "./GifDescriptionField.scss";

interface IGifDescriptionField {
  isVerified: boolean;
  description: string;
  onVerifyClick?: () => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const GifDescriptionField: React.FC<IGifDescriptionField> = memo(({
  isVerified,
  description,
  onChange,
  onVerifyClick
}) => {

  const unverifiedDescription = (
    <>
          Content with engaging descriptions get 2.5 times more likes than content without but they’re only available
          for verified users.
    </>
  );

  const verifiedDescription = (
    <>
          Did you know that content with an engaging description is 2.5
          times more likely to get likes than content without. Add yours here.
    </>
  );
  const gifDescription = isVerified ? verifiedDescription : unverifiedDescription;

  const placeHolder = "Enhance your content's visibility with context! Describe what's " +
      "happening, who's involved, or how you're feeling, to engage viewers effectively.";

  return (
    <div className="GifDescriptionField">
      <p className="GifDescriptionField-Title">{gifDescription}</p>
      {!isVerified && <span className="GifDescriptionField-SubTitle">Click below to apply for your account to be verified</span>}
      <TextArea
        value={description}
        onChange={onChange}
        placeholder={placeHolder}
        rows={5}
        disabled={!isVerified}
      />
      {!isVerified && (
        <VerifiedButton onClick={onVerifyClick} />
      )}
    </div>
  );
});
